@if ((cart$ | async); as cart) {
  <div class="cx-review">
    <h4 class="cx-review-title d-none d-lg-block d-xl-block">
      {{ 'uigCheckout.checkoutReview.review' | cxTranslate }}
    </h4>
    <div class="cx-review-summary row">
      <div class="col-md-12 col-lg-6 col-xl-6 cx-review-payment-col">
        <ng-container *ngTemplateOutlet="invoiceAddress"></ng-container>
        <ng-container *ngTemplateOutlet="poNumber"></ng-container>
        <ng-container *ngTemplateOutlet="deliveryTicket"></ng-container>
      </div>
      <div class="col-md-12 col-lg-6 col-xl-6 cx-review-shipping-col">
        <ng-container *ngTemplateOutlet="deliveryMode"></ng-container>
        <ng-container *ngTemplateOutlet="shippingAddress"></ng-container>
      </div>
    </div>
    <ng-template #invoiceAddress>
      @if (cart.invoiceAddress) {
        <div class="cx-review-summary-card">
          <div class="cx-card">
            <div class="card-body cx-card-body">
              <h4 class="cx-card-title">
                {{ 'uigCheckout.checkoutReview.invoiceAddress' | cxTranslate }}
              </h4>
              <div class="cx-card-container">
                {{ cart.invoiceAddress?.companyName }}<br>
                {{ cart.invoiceAddress?.line1 }}<br>
                {{ cart.invoiceAddress?.postalCode }} {{ cart.invoiceAddress?.town }}<br>
                {{ cart.invoiceAddress?.country?.name }}
              </div>
            </div>
          </div>
        </div>
      }
    </ng-template>
    <ng-template #poNumber>
      <div class="cx-review-summary-card">
        <div class="cx-card">
          <div class="card-body cx-card-body">
            <h4 class="cx-card-title cx-card-title--optional">
              {{ 'uigCheckout.checkoutReview.orderNumber' | cxTranslate }}<br>
            </h4>
            <div class="cx-card-container">
              <input
                class="form-control"
                placeholder="{{ 'uigCheckout.checkoutReview.orderNumberPlaceHolder' | cxTranslate }}"
                [(ngModel)]="placeOrderForm.purchaseOrderNumber"
                maxlength="100">
              </div>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template #deliveryTicket>
        <div class="cx-review-summary-card">
          <div class="cx-card">
            <div class="card-body cx-card-body">
              <h4 class="cx-card-title cx-card-title--optional">
                {{ 'uigCheckout.checkoutReview.deliveryTicket' | cxTranslate }}<br>
              </h4>
              <div class="cx-card-container">
                <textarea
                  class="form-control"
                  name="deliveryTicket"
                  rows="5"
                  cols="25"
                [(ngModel)]="placeOrderForm.deliveryTicket"></textarea>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template #deliveryMode>
        <div class="cx-review-summary-card cx-review-card-shipping">
          <div class="cx-card">
            <div class="card-body cx-card-body">
              <h4 class="cx-card-title">
                {{ 'uigCheckout.checkoutReview.deliveryOptions' | cxTranslate }}
              </h4>
              <div class="cx-card-container">
                <div class="form-check">
                  @for (deliveryMode of deliveryModes; track deliveryMode; let i = $index) {
                    <span>
                      <input type="radio"
                        checked="{{deliveryMode.selected ? 'checked' : ''}}"
                        name="deliveryMode.code_radio"
                        id="{{deliveryMode.code}}_radio"
                        value="{{deliveryMode.code}}"
                        (change)="selectDeliveryMode(deliveryMode.code)"/>
                        <label for="{{deliveryMode.code}}_radio">{{deliveryMode.name}}</label>
                      </span>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
        <ng-template #shippingAddress>
          @if (addressSelectionActivated) {
            <div class="cx-review-summary-card cx-review-card-address">
              <div class="cx-card">
                <div class="card-body cx-card-body">
                  <h4 class="cx-card-title">
                    {{ 'uigCheckout.checkoutReview.deliveryAddress' | cxTranslate }}
                  </h4>
                  <div class="cx-card-container">
                    <div class="form-check">
                      <input type="radio"
                        checked="{{!placeOrderForm.isDirectDelivery ? 'checked' : ''}}"
                        name="deliveryAddressMode_radio"
                        id="deliveryDefaultAddressDefault_radio"
                        value="{{placeOrderForm.isDirectDelivery}}"
                        (change)="selectDeliveryAddressMode(false)"/>
                        <ng-select
                          id="deliveryAddress"
                          class="review-submit__delivery-address"
                          [searchable]="false"
                          [clearable]="false"
                          (change)="placeOrderForm.isDirectDelivery = false"
                          [(ngModel)]="placeOrderForm.selectedDeliveryAddressId"
                          >
                          @for (deliveryAddresse of deliveryAddresses; track deliveryAddresse) {
                            <ng-option [value]="deliveryAddresse.id">
                              <div>{{ deliveryAddresse.companyName }}</div>
                              <div>{{ deliveryAddresse.line1 }}</div>
                              <div>{{ deliveryAddresse.postalCode }} {{ deliveryAddresse.town }}</div>
                              <div>{{ deliveryAddresse.country?.name }}</div>
                            </ng-option>
                          }
                        </ng-select>
                        @if (isDirectDeliveryAllowed) {
                          <div>
                            <br>
                              <input type="radio"
                                checked="{{placeOrderForm.isDirectDelivery ? 'checked' : ''}}"
                                name="deliveryAddressMode_radio"
                                id="deliveryDirectAddressMode_radio"
                                value="{{placeOrderForm.isDirectDelivery}}"
                                (change)="selectDeliveryAddressMode(true)"/>
                                <label for="deliveryDirectAddressMode_radio">{{ 'uigCheckout.checkoutReview.directDelivery' | cxTranslate }}</label>
                                <div class="direct-delivery-costs-note">
                                  {{ 'uigCheckout.checkoutReview.directDeliveryCostNote' | cxTranslate: {directCost: cart.deliveryCostDirect?.formattedValue, directBulkyCost: cart.deliveryCostBulkyDirect?.formattedValue} }}
                                </div>
                                @if (!directDeliveryAddress) {
                                  <button class="btn btn-secondary btn-block mb-6" type="button" (click)="onDirectDelivery()">
                                    {{ 'uigCheckout.checkoutReview.directDeliveryButton' | cxTranslate }}
                                  </button>
                                }
                                @if (directDeliveryAddress) {
                                  <div>
                                    {{directDeliveryAddress.firstName}}<br>
                                    @if (directDeliveryAddress.nameSuffix) {
                                      <span>{{directDeliveryAddress.nameSuffix}}<br></span>
                                    }
                                    {{directDeliveryAddress.line1}}<br>
                                    {{directDeliveryAddress.postalCode}} {{directDeliveryAddress.town}}<br>
                                    {{directDeliveryAddress.email}}<br>
                                    {{directDeliveryAddress.phone}}<br>
                                    <br>
                                      <button class="btn btn-secondary mb-1" type="button" (click)="onDeleteDirectDelivery()">
                                        {{ 'uigCheckout.checkoutReview.directDeliveryDeleteButton' | cxTranslate }}
                                      </button>&nbsp;
                                      <button class="btn btn-secondary mb-1" type="button" (click)="onDirectDelivery()">
                                        {{ 'uigCheckout.checkoutReview.directDeliveryUpdateButton' | cxTranslate }}
                                      </button><br>
                                      <br>
                                        {{ 'uigCheckout.checkoutReview.directDeliveryNote' | cxTranslate }}
                                      </div>
                                    }
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                  </ng-template>
                  <!-- CART ITEM SECTION -->
                  <ng-container>
                    <h4 class="cx-review-cart-heading d-block">
                      {{ 'uigCheckout.orderItemsCaption' | cxTranslate }}
                    </h4>
                    @if (entries$ | async; as entries) {
                      <div
                        class="cx-review-cart-item col-md-12"
                        >
                        <app-uig-grouped-cart-item-list
                          [cartId]="cart.code"
                          [items]="entries"
                          [readonly]="true"
                          [promotionLocation]="promotionLocation"
                          [vendorEntryGroups]="(vendorEntryGroups$ | async)"
                        ></app-uig-grouped-cart-item-list>
                      </div>
                    }
                  </ng-container>
                </div>
              }
